import React from 'react';
import { Heart } from 'lucide-react';

export const PrayerCard = ({ prayer }) => {
  return (
    <div 
      data-testid="prayer-card"
      className="my-12 p-8 md:p-10 bg-gradient-to-br from-sky-light/50 to-sage-light/30 rounded-2xl shadow-[0_4px_20px_-2px_rgba(124,154,146,0.15)] animate-slide-up"
    >
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-full bg-sage/20 flex items-center justify-center">
          <Heart className="w-5 h-5 text-sage" />
        </div>
        <h3 className="font-heading text-2xl text-charcoal">Closing Prayer</h3>
      </div>
      <div className="prose prose-lg max-w-none">
        {prayer.split('\n\n').map((paragraph, index) => (
          <p 
            key={index} 
            className="font-body text-charcoal/90 leading-relaxed mb-4 last:mb-0"
          >
            {paragraph}
          </p>
        ))}
      </div>
    </div>
  );
};
